/* eslint-disable react-hooks/exhaustive-deps */
import "./Header.css";
import React, { useEffect, useState } from "react";
import { Avatar, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import { useAuth } from "../../auth/auth";
import { removeUser } from "../../auth/actions";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { getInitials, getRandomColor } from "../../utils/utils";

const Header = () => {
  const { state, dispatch } = useAuth();
  const [avatarColor, setAvatarColor] = useState<string>("");
  const [anchors, setAnchors] = useState<{ [key: string]: HTMLElement | null }>(
    {
      user: null,
      staff: null,
      rtdata: null,
      sentinel: null,
      oncall: null,
      mobile: null,
    }
  );

  useEffect(() => {
    let storedColor = localStorage.getItem("avatarColor");
    if (!storedColor) {
      storedColor = getRandomColor();
      localStorage.setItem("avatarColor", storedColor);
    }
    setAvatarColor(storedColor);
  }, []);

  const handleOpen =
    (menu: string) => (event: React.MouseEvent<HTMLElement>) => {
      setAnchors((prev) => ({ ...prev, [menu]: event.currentTarget }));
    };

  const handleClose = (menu: string) => () => {
    setAnchors((prev) => ({ ...prev, [menu]: null }));
  };

  const logOut = () => {
    dispatch(removeUser());
    localStorage.removeItem("avatarColor");
  };

  const menuConfig = [
    {
      key: "staff",
      label: "Staff",
      items: [
        { label: "Staff Details", path: "/pace-team/resourcing/staff-details" },
        { label: "Workforce Map", path: "/pace-team/resourcing/workforce-map" },
        { label: "Cancelled Shifts", path: "/pace-team/cancelled-shifts"},
        { label: "Profile Update Requests", path: "/pace-team/profile-update-requests" },
      ],
    },
    {
      key: "rtdata",
      label: "RT Data",
      items: [
        { label: "Clients", path: "/pace-team/collaborations/clients" },
        { label: "Projects", path: "/pace-team/collaborations/projects" },
        { label: 'Pace Site Contact', path: '/pace-team/rt-data/pace-site-contact' },
        { label: 'Client Site Contact', path: '/pace-team/rt-data/client-site-contact' },
        { label: 'Work Role Suggestions', path: '/pace-team/rt-data/work-role-suggestions' },
        { label: "Payment Methods", path: "/pace-team/payroll/payment-method" },
        {
          label: "Authorized Drivers",
          path: "/pace-team/resourcing/authorized-drivers",
        },
        {
          label: "Distance Matrices",
          path: "/pace-team/resourcing/distance-matrices",
        },
        {
          label: "Calendar Downloads",
          path: "/pace-team/calendar-downloads",
        },
      ],
    },
    {
      key: "sentinel",
      label: "Sentinel",
      items: [
        { label: "Competencies", path: "/pace-team/competencies" },
        { label: "Experiences", path: "/pace-team/experiences" },
        { label: "Tickets", path: "/pace-team/tickets" },
        { label: "Onboarding Forms", path: "/pace-team/onboarding-forms" },
        { label: "FRI Calculations", path: "/pace-team/fatigue-calculations" },
        { label: "Upload Weekly Sheet", path: "/pace-team/upload-weekly-sheet" },
      ],
    },
    {
      key: "oncall",
      label: "On Call",
      items: [
        { label: "Live Tracker", path: "/pace-team/resourcing/live-tracker" },
        {
          label: "Location Logger",
          path: "https://railresourcing.pace-is.co.uk/pace-team/resource-tracker/location-logger",
          external: true,
        },
        { label: "Signin Sheet", path: "/pace-team/resource-tracker/signin" },
      ],
    },
    {
      key: 'report',
      label: 'Report',
      items: [
        { label: 'Generate Advisory Fatigues', path: `/pace-team/resourcing/generate-fatigues` },
        { label: 'Generate Hours Report', path: `/pace-team/resourcing/generate-hours-report` },
      ],
    },
    {
      key: "mobile",
      label: "Mobile",
      iconColor: "orangered",
      items: [
        { label: "Job Listings", path: "/pace-team/resourcing/job-listings" },
        { label: "Web Forms", path: "/pace-team/resourcing/web-forms" },
        // {
        //   label: "Workers Availability",
        //   path: "/pace-team/resourcing/workers-availability",
        // },
      ],
    },
  ];

  return (
    <div className="main-header">
      <Link to="/pace-team/resourcing/resource-tracker" className="logo">
        PACE
      </Link>
      <div className="link" style={{ textDecoration: "none" }}>
        <Link to="/pace-team/resourcing/resource-tracker" className="rt">
          Resource Tracker
        </Link>

        {menuConfig.map(({ key, label, items, iconColor }) => (
          <React.Fragment key={key}>
            <div className="rt" onClick={handleOpen(key)}>
              {label} <FontAwesomeIcon icon={faChevronDown} color={iconColor} />
            </div>
            <Menu
              anchorEl={anchors[key]}
              open={Boolean(anchors[key])}
              onClose={handleClose(key)}
            >
              {items.map(({ label, path, external }: any) =>
                external ? (
                  <MenuItem key={label} onClick={handleClose(key)}>
                    <a
                      href={path}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="dropdown"
                    >
                      {label}
                    </a>
                  </MenuItem>
                ) : (
                  <Link
                    to={path}
                    className="dropdown"
                    key={label}
                    onClick={handleClose(key)}
                  >
                    <MenuItem>{label}</MenuItem>
                  </Link>
                )
              )}
            </Menu>
          </React.Fragment>
        ))}

        <Tooltip title="">
          <IconButton onClick={handleOpen("user")}>
            <Avatar
              sx={{
                height: 35,
                width: 35,
                fontSize: 16,
                backgroundColor: avatarColor,
              }}
            >
              {getInitials(state.user?.name, state.user?.surname)}
            </Avatar>
          </IconButton>
        </Tooltip>
        <Menu
          anchorEl={anchors.user}
          open={Boolean(anchors.user)}
          onClose={handleClose("user")}
        >
          <Link
            to="/pace-team/resourcing/my-profile"
            className="dropdown"
            onClick={handleClose("user")}
          >
            <MenuItem sx={{ width: 200 }}>My Profile</MenuItem>
          </Link>
          <Link
            to="/pace-team/resourcing/dashboard"
            className="dropdown"
            onClick={handleClose("user")}
          >
            <MenuItem sx={{ width: 200 }}>Dashboard</MenuItem>
          </Link>
          <MenuItem
            sx={{ width: 200 }}
            onClick={() => {
              handleClose("user")();
              logOut();
            }}
          >
            Logout
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
};

export default Header;
